import { RootState } from "../../../store/types";
import { connect } from "react-redux";
import Chart from "./Chart";
import { getVolumeTrend } from "../../../utils/midShiftActuals";

const mapStateToProps = (state: RootState) => {
    const projectedPrimaryGradingVolume = getVolumeTrend(state.reviewAndPublish.shiftPlanOutput);
    const primaryGradingVolumeTotal = state.reviewAndPublish.shiftPlanOutput?.primaryGradingVolume?.recommended?.total;

    return {
        projectedPrimaryGradingVolume,
        primaryGradingVolumeTotal
    };
};

export default connect(mapStateToProps)(Chart);
